<script>
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";

export default {
  name: "ErreurCreationCarteFidelite",
  components: {
    Icon,
    Button,
    Titre
  },
  props: {
    carteDejaExistante: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<template>
  <div class="c-erreur-creation-carte-fidelite">
    <Icon
      name="alert-circle-outline"
      variant="alert"
      size="lg"
      class="u-mb-xs"
    />
    <Titre
      tag="h1"
      size="md"
      variant="alert"
      class="u-mb-sm"
    >
      Une erreur est survenue lors de la création de votre carte de fidélité
    </Titre>
    <template v-if="carteDejaExistante">
      <p>
        Il semblerait que vous possédiez déjà un compte fidélité associé à vos nom et prénom.<br><br>
        <strong>Veuillez vous adresser au Village des services de votre magasin pour créer votre nouvelle carte.</strong>
      </p>
    </template>
    <template v-else>
      <p>
        Nous vous invitons à réessayer ultérieurement.<br><br>
        Veuillez nous excuser pour la gêne occasionnée.
      </p>
      <Button
        variant="primary"
        radius="full"
        size="md"
        class="u-mt-lg"
        to="/creation-carte-fidelite"
      >
        Créer à nouveau une carte
      </Button>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/erreur-creation-carte-fidelite.scss";
</style>
